import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a6a3d18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "path-path__header page-header" }
const _hoisted_2 = { class: "file-tab" }
const _hoisted_3 = { class: "path-path__paths" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "qh-icon-more" }, null, -1))
const _hoisted_6 = { class: "file-tab-head" }
const _hoisted_7 = { class: "file-tab-head-name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "文件名", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "file-tab-head-size" }, " 大小 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "file-tab-head-time" }, " 创建时间 ", -1))
const _hoisted_11 = { class: "path-content" }
const _hoisted_12 = { class: "loading-more" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "qh-icon-loading-small" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "path-item__icon" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "path-item__info" }
const _hoisted_19 = { class: "path-item__name" }
const _hoisted_20 = { class: "path-item__time file-size-pc" }
const _hoisted_21 = {
  key: 0,
  class: "path-item__time"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_23 = { class: "file-size-mobile" }
const _hoisted_24 = {
  key: 0,
  class: "warn"
}
const _hoisted_25 = {
  key: 1,
  class: "path-item__time"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "path-content__empty" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "path-content__empty-img" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "空文件夹", -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 0,
  class: "path-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadMore = _resolveComponent("LoadMore")!
  const _component_HeziPathSelector = _resolveComponent("HeziPathSelector")!
  const _directive_see = _resolveDirective("see")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pan-path__wrapper is-light", {
      'sl-full': _ctx.isFullScreen,
      'android-padding': _ctx.isAndroid,
      'ios-padding': _ctx.isIOS,
      'un-hezi-native': !_ctx.isHeziNative
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isSelecting || _ctx.isLargeViewPort)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "javascript:;",
            class: "qh-icon-back",
            style: {"font-size":"16px","margin-right":"20px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args))),
            title: "返回"
          }))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: "javascript:;",
            class: "pan-cancel",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)))
          }, "取消")),
      _createElementVNode("h1", null, _toDisplayString(_ctx.chooseFile.length ? `已选择${_ctx.chooseFile.length}项` : (_ctx.isSelecting && !_ctx.isLargeViewPort ? '请选择' : '从云盘下载')), 1),
      (_ctx.isSelecting && !_ctx.isLargeViewPort)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            href: "javascript:;",
            class: "pan-select-all",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSelectAll && _ctx.handleSelectAll(...args)))
          }, _toDisplayString(_ctx.isSelectAll ? '取消全选' : '全选'), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _withDirectives(_createElementVNode("a", {
          class: _normalizeClass(["path-path__paths-goback", { disabled: _ctx.chooseFile.length > 0 || _ctx.folderPath.length <= 1 }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleClickBreadCrumb(_ctx.folderPath.at(-2))))
        }, "返回上一级", 2), [
          [_vShow, _ctx.folderPath.length > 1]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folderPath, (folder, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: _normalizeClass({ 'path-disable': _ctx.chooseFile.length > 0 || _ctx.isSelecting && !_ctx.isLargeViewPort }),
            key: index,
            onClick: ($event: any) => (_ctx.handleClickBreadCrumb(folder))
          }, [
            (folder.id === '')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(folder.showName), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(folder.showName), 1)
                ], 64))
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, [
          _createElementVNode("i", {
            class: _normalizeClass(["file-pc-check", {
              'un-check': _ctx.chooseFile.length === 0,
              'check-part': _ctx.chooseFile.length > 0 && !_ctx.isSelectAll,
              'check': _ctx.isSelectAll,
              'disabled': !_ctx.canDownloadedFileNum
            }]),
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSelectAll && _ctx.handleSelectAll(...args)))
          }, null, 2),
          _hoisted_8
        ]),
        _hoisted_9,
        _hoisted_10
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _withDirectives(_createElementVNode("p", _hoisted_12, _hoisted_14, 512), [
        [_vShow, _ctx.files.length < 1 && _ctx.isLoading]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (id, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["path-item", { disable: _ctx.all[id].auditDisableType !== 0, 'check': _ctx.all[id].checkType !== 0 }]),
          key: index,
          onClick: ($event: any) => (_ctx.handleClickItem(id))
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("img", {
              src: _ctx.all[id].icon_link,
              alt: ""
            }, null, 8, _hoisted_17)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.all[id].name), 1),
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.all[id].kind === 'drive#file' ? _ctx.bytesToSize(+_ctx.all[id].size) : '-'), 1),
            (_ctx.all[id].name !== '超级保险箱')
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_ctx.parseTime(_ctx.all[id].modified_time, '{y}-{m}-{d} {h}:{i}')) + " ", 1),
                  _hoisted_22,
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.all[id].kind === 'drive#file' ? _ctx.bytesToSize(+_ctx.all[id].size) : ''), 1),
                  (_ctx.all[id].auditDisableType === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "!"))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_25, " 文件随意存，保障数据安全 "))
          ]),
          _createElementVNode("div", {
            class: "path-item__select",
            onClick: _withModifiers(($event: any) => (_ctx.handleSelectItem(_ctx.all[id])), ["stop"])
          }, [
            (!_ctx.all[id].isDefault)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass(["file-pc-check", {
              'un-check': _ctx.all[id].checkType === 0,
              'check': _ctx.all[id].checkType !== 0,
            }])
                }, null, 2))
              : _createCommentVNode("", true),
            (!_ctx.all[id].isDefault)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass([{
              'qh-icon-check': _ctx.all[id].checkType === 0,
              'qh-icon-checked': _ctx.all[id].checkType !== 0,
              'is-selecting': !_ctx.isSelecting
            }, "check-icon"])
                }, null, 2))
              : _createCommentVNode("", true)
          ], 8, _hoisted_26)
        ], 10, _hoisted_15))
      }), 128)),
      _withDirectives(_createElementVNode("div", _hoisted_27, _hoisted_30, 512), [
        [_vShow, !_ctx.isLoading && _ctx.files.length === 0]
      ]),
      (!!_ctx.next_page_token && !_ctx.isSelecting)
        ? _withDirectives((_openBlock(), _createBlock(_component_LoadMore, {
            key: 0,
            onClick: _ctx.loadMore
          }, null, 8, ["onClick"])), [
            [_directive_see, _ctx.loadMore]
          ])
        : _createCommentVNode("", true)
    ]),
    (_ctx.hasFooter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("a", {
            href: "javascript:;",
            class: "path-cancel",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('cancel')))
          }, "取消"),
          _createElementVNode("a", {
            href: "javascript:;",
            class: "path-confirm",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
          }, "确定")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_HeziPathSelector, {
      selects: _ctx.chooseFile,
      visible: _ctx.hzSelectorVisible,
      "is-large-view-port": _ctx.isLargeViewPort,
      onRetrieve: _ctx.confirm
    }, null, 8, ["selects", "visible", "is-large-view-port", "onRetrieve"])
  ], 2))
}